module.exports = __webpack_public_path__ + "static/media/wind.3e2a1b16.svg";